<div class="container text-center pdd-top-30">
    <div
        style="
            text-align: left;
            font-weight: bold;
            padding-bottom: 60px;
            padding-top: 60px;
        "
    >
        <p>{{ 'pages.zoho-sync.description' | translate }}</p>
        <p>{{ 'pages.zoho-sync.note.title' | translate }}</p>
        <ol type="1">
            <li>{{ 'pages.zoho-sync.note.frequency' | translate }}</li>
            <li>{{ 'pages.zoho-sync.note.message' | translate }}</li>
        </ol>
    </div>

    <button class="btn btn-info" (click)="syncZohoData()">
        {{ 'pages.zoho-sync.button' | translate }}
    </button>
</div>

<form
    [ngClass]="{
        hidden: true
    }"
    [action]="url"
    method="get"
    name="zohoSync"
    #zohoSyncForm
    id="zoho-sync-form"
>
    <input type="hidden" name="scope" [value]="scope" />
    <input type="hidden" name="client_id" [value]="client_id" />
    <input type="hidden" name="state" [value]="state" />
    <input type="hidden" name="response_type" [value]="response_type" />
    <input type="hidden" name="redirect_uri" [value]="redirect_uri" />
    <input type="hidden" name="access_type" [value]="'offline'" />
    <input type="hidden" name="prompt" [value]="'consent'" />

    <button type="submit" value="submit" (click)="zohoSyncForm.submit()">
        {{ 'pages.zoho-sync.submit' | translate }}
    </button>
</form>
